module.exports = __webpack_public_path__ + "img/4.e4687338.png";